(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var form = document.getElementById('FilterForm');
  if (form) {
    form.addEventListener('change', function () { form.submit(); });
  }
  var sort = document.getElementById('SortBy');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var json = document.getElementById('ProductJson');
  var variants = json ? JSON.parse(json.textContent) : [];
  var idInput = document.getElementById('variantId');
  var addBtn = document.getElementById('addToCart');
  var addLabel = document.getElementById('addLabel');

  function selectedValues() {
    return Array.prototype.map.call(form.querySelectorAll('.opt__row'), function (row) {
      var active = row.querySelector('[data-value].active');
      return active ? active.getAttribute('data-value') : null;
    });
  }
  function matchVariant() {
    var vals = selectedValues();
    return variants.find(function (v) {
      return vals.every(function (val, i) { return val == null || v.options[i] === val; });
    });
  }
  function update() {
    var v = matchVariant();
    if (!v) {
      if (addBtn) { addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Nedostupná kombinace'; }
      return;
    }
    if (idInput) idInput.value = v.id;
    if (addBtn) {
      addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Přidat do košíku' : 'Vyprodáno';
    }
  }
  form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-value]');
    if (!b) return;
    var row = b.closest('.opt__row');
    Array.prototype.forEach.call(row.querySelectorAll('[data-value]'), function (x) { x.classList.remove('active'); });
    b.classList.add('active');
    var label = form.querySelector('[data-opt-label="' + row.getAttribute('data-option-position') + '"]');
    if (label) label.textContent = b.getAttribute('data-value');
    update();
  });

  var qty = document.getElementById('qty');
  var minus = document.getElementById('qtyMinus');
  var plus = document.getElementById('qtyPlus');
  if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
  if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

  update();
})();

  } catch(e) { console.error(e); }
})();
})();
